module.exports = new __parcel__URL__("neon_gold_storage_level_13.6e31ce40.png").toString();